import aboutData from "../data/about";
import ContactForm from "../components/ContactForm";


const About = () => {
    const { title, content, image } = aboutData;

    return (
        <div className="about-container">
            <div className="about-content">

                <div className="bio">
                    <h2>{title}</h2>
                    <img src={image} alt="me" style={{ width: "100%" }} />
                    <p>{content}</p>
                </div>

                <div className="about-form">
                    <ContactForm />
                </div>
            </div>
        </div>
    );
};

export default About;
